export const strings = {
	en: {
		legalFooter: 'legal notice / privacy policy'
	},
	de: {
		legalFooter: 'impressum / datenschutzerklärung'
	}
};